import { Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import Iconify from 'src/components/Iconify';
import { APP_DUAL_LIST, APP_MEDIA_REWARDS_LIST } from 'src/constants/queryKeys';
import { PATH_DASHBOARD } from 'src/routes/paths';
import useFormsModalStore from 'src/store/forms';

const DuelTableBreadcrumb = ({ applicationDetails }) => {
  const { setModal } = useFormsModalStore();

  return (
    <HeaderBreadcrumbs
      heading={`پاداش مشاهده ویدیوهای محصول ${applicationDetails?.ApplicationTitle}`}
      links={[
        { name: 'داشبورد', href: PATH_DASHBOARD.general.home },
        { name: `پاداش مشاهده ویدیوهای محصول ${applicationDetails?.ApplicationTitle}`, href: null },
      ]}
      action={
        <Button
          variant="contained"
          component={RouterLink}
          startIcon={<Iconify icon={'eva:plus-fill'} />}
          onClick={() => setModal({ isOpen: true, data: null, type: APP_MEDIA_REWARDS_LIST, title: 'ایجاد پاداش' })}
        >
          ایجاد پاداش
        </Button>
      }
    />
  );
};

export default DuelTableBreadcrumb;
